import { Col, Row } from 'antd'
import Select from 'components/Select'
import WholeFolder from 'components/icons/WholeFolder'
import React, { useEffect, useState } from 'react'
import SelectComponent from '../../../components/Select/SelectComponent'
import {
  FilterAlignInner,
  FilterAlignWhole,
  FilterCol1,
  FilterFolderAbsolute,
  FilterFolderRelative,
  FolderHeading,
} from '../style'

export default function FilterData({
  degreeData,
  handleDegreeChange,
  degreeValue,
  departData,
  departValue,
  handleDepartChange,
  domainData,
  domainValue,
  handleDomainChange,
  GroupBy,
  BreadShowStudent,
  yearData,
  yearValue,
  handleYearChange,
}) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <FilterAlignWhole>
      <FilterAlignInner>
        <FilterCol1>
          <WholeFolder />
          <FolderHeading>
            {GroupBy == 'students' || GroupBy == 'stream'
              ? 'Department'
              : GroupBy}
          </FolderHeading>
        </FilterCol1>
        <Row style={{ gap: '1.5rem' }}>
          {BreadShowStudent && (
            <Col>
              <FilterFolderRelative>
                <FilterFolderAbsolute>Domain</FilterFolderAbsolute>

                <Select
                  width="150px"
                  showSearch={true}
                  allowClear={true}
                  OptionData={domainData}
                  placeholder="Select Domain"
                  valueParam="id"
                  nameParam="name"
                  value={domainValue}
                  colorstyle={true}
                  onChange={handleDomainChange}
                  filterOption={(input, option) =>
                    option?.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                />
              </FilterFolderRelative>
            </Col>
          )}

          {BreadShowStudent && (
            <Col>
              <FilterFolderRelative>
                <FilterFolderAbsolute disabled={domainValue === ''}>
                  Degree
                </FilterFolderAbsolute>
                <Select
                  width="150px"
                  disabled={domainValue === ''}
                  showSearch={true}
                  allowClear={true}
                  OptionData={degreeData}
                  placeholder="Select Degree"
                  valueParam="id"
                  nameParam="name"
                  value={degreeValue}
                  colorstyle={true}
                  onChange={handleDegreeChange}
                  filterOption={(input, option) =>
                    option?.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                />
              </FilterFolderRelative>
            </Col>
          )}
          {BreadShowStudent && (
            <Col>
              <FilterFolderRelative>
                <FilterFolderAbsolute disabled={degreeValue === ''}>
                  Dept.
                </FilterFolderAbsolute>
                <Select
                  width="150px"
                  disabled={degreeValue === ''}
                  showSearch={true}
                  allowClear={true}
                  OptionData={departData}
                  placeholder="Select Dept"
                  valueParam="id"
                  nameParam="name"
                  colorstyle={true}
                  value={departValue}
                  onChange={handleDepartChange}
                  filterOption={(input, option) =>
                    option?.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                />
              </FilterFolderRelative>
            </Col>
          )}

          {yearData?.length !== 0 && windowWidth <= 1440 && (
            <Col>
              <FilterFolderRelative>
                <FilterFolderAbsolute>Passing Year</FilterFolderAbsolute>

                <SelectComponent
                  options={yearData?.map(item => {
                    return { label: item.year, value: item.endedOn }
                  })}
                  value={yearValue}
                  placeholder={'Select Year'}
                  width="150px"
                  onChange={handleYearChange}
                  showSearch={true}
                  allowClear={true}
                  filterOption={(input, option) => {
                    const childrenString = option?.children
                      .toString()
                      .toLowerCase()
                    return childrenString?.includes(input.toLowerCase())
                  }}
                />
              </FilterFolderRelative>
            </Col>
          )}
        </Row>
        {yearData?.length !== 0 && windowWidth > 1440 && (
          <Col>
            <FilterFolderRelative>
              <FilterFolderAbsolute>Passing Year</FilterFolderAbsolute>
              <SelectComponent
                options={yearData?.map(item => {
                  return { label: item.year, value: item.endedOn }
                })}
                value={yearValue}
                placeholder={'Select Year'}
                width="150px"
                onChange={handleYearChange}
                showSearch={true}
                allowClear={true}
                filterOption={(input, option) => {
                  const childrenString = option?.children
                    .toString()
                    .toLowerCase()
                  return childrenString?.includes(input.toLowerCase())
                }}
              />
            </FilterFolderRelative>
          </Col>
        )}
      </FilterAlignInner>
    </FilterAlignWhole>
  )
}
